import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { API_GET_APP_INFO } from "../../api/company.service";
import "../Company/company.css";

const formatDate = (timestamp) => {
  if (!timestamp) return "-";
  const date = new Date(timestamp);
  return date.toLocaleString();
};

const AppInfo = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState({});

  useEffect(() => {
    const fetchAppInfo = async () => {
      try {
        const response = await API_GET_APP_INFO(companyId);
        setCompany(response?.app || {});
      } catch (error) {
        console.error("Failed to fetch app info:", error);
      }
    };

    if (companyId) {
      fetchAppInfo();
    }
  }, [companyId]);

  const infoItems = useMemo(
    () => [
      { label: "Name", value: company.name },
      { label: "Business ID", value: company.businessId },
      { label: "Phone", value: company.phone ? `+${company.phone}` : "-" },
      { label: "Phone ID", value: company.phoneId },
      { label: "Language Code", value: company.languageCode },
      { label: "Provider", value: company.provider },
      { label: "Namespace", value: company.namespace },
      { label: "Live", value: company.live ? "Yes" : "No" },
      { label: "Version", value: company.version },
      { label: "Type", value: company.type },
      { label: "Federated", value: company.federated ? "Yes" : "No" },
      {
        label: "Template Messaging",
        value: company.templateMessaging ? "Enabled" : "Disabled",
      },
      { label: "Embed Allowed", value: company.embedAllowed ? "Yes" : "No" },
      {
        label: "Opt-in URL Disabled",
        value: company.disableOptinPrefUrl ? "Yes" : "No",
      },
      { label: "Storage Region", value: company.storageRegion },
      {
        label: "New Billing Enabled",
        value: company.newBillingEnabled ? "Yes" : "No",
      },
      { label: "Stopped", value: company.stopped ? "Yes" : "No" },
      { label: "Created On", value: formatDate(company.createdOn) },
      { label: "Modified On", value: formatDate(company.modifiedOn) },
      { label: "Live Timestamp", value: formatDate(company.liveTs) },
    ],
    [company]
  );

  return (
    <div className="company-tab-panel">
      <div className="surface-panel">
        <div className="surface-panel-header">
          <div>
            <h2 className="surface-panel-title">Facebook app information</h2>
          </div>
        </div>

        <div className="company-data-grid">
          {infoItems.map((item) => (
            <div className="company-data-card" key={item.label}>
              <label>{item.label}</label>
              <p>{item.value || "-"}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppInfo;
